import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import TeamStatsGrid from './TeamStatsGrid';
import TeamChartWithDropdown from './TeamChartWithDropdown';
import TopPerformers from './TopPerformers';

/**
 * TeamInsightsList - Main component for team insights
 * Components will be built one by one as instructed by the user.
 */
const TeamInsightsList = ({ stats, leadsData, viewsData, linkTapsData, recentActivity, activeTeamMembersCount, members = [] }) => {
    return (
        <Box sx={{ mt: 3 }}>
            {/* First Row: Stats Grid - Leads, Views, Contacts Downloaded, Active Team Members */}
            <Box sx={{ marginTop: '24px' }}>
                <TeamStatsGrid
                    stats={stats}
                    activeTeamMembersCount={activeTeamMembersCount}
                />
            </Box>

            {/* Chart with Dropdown - Leads, Views, Active Members */}
            <TeamChartWithDropdown
                leadsData={leadsData}
                viewsData={viewsData}
                activeTeamMembersCount={activeTeamMembersCount}
                members={members}
            />

            {/* Top Performers Section */}
            <TopPerformers
                leadsData={leadsData}
                viewsData={viewsData}
                members={members}
            />
        </Box>
    );
};

TeamInsightsList.propTypes = {
    stats: PropTypes.object,
    leadsData: PropTypes.object,
    viewsData: PropTypes.object,
    linkTapsData: PropTypes.object,
    recentActivity: PropTypes.array,
    activeTeamMembersCount: PropTypes.number,
    members: PropTypes.array
};

export default TeamInsightsList;

